import { jsx as v } from "react/jsx-runtime";
import { isCancel as C } from "axios";
import { useState as P, useEffect as D, useCallback as U } from "react";
import { AbortError as V } from "./index3.mjs";
import { AccessDenied as F } from "./index4.mjs";
import { BadRequest as M } from "./index5.mjs";
import { ConflictError as S } from "./index6.mjs";
import { FailedDependency as x } from "./index9.mjs";
import { InternalError as j } from "./index10.mjs";
import { LockedError as q } from "./index12.mjs";
import { MaintenanceError as R } from "./index13.mjs";
import { NotFound as X } from "./index15.mjs";
import { PayloadTooLarge as k } from "./index16.mjs";
import { UnauthorizedResponse as G } from "./index17.mjs";
import { UnprocessableContentError as J } from "./index18.mjs";
import { checkAreThereFieldsErrors as K } from "./index19.mjs";
import { useTranslation as Q } from "./index2.mjs";
const _e = ({
  httpClient: A,
  useRouter: T,
  toast: o
}) => function({
  method: a,
  showFieldsErrorToast: p,
  stopErrorPropagation: O,
  badRequestHandler: n,
  unauthorizedResponseHandler: f,
  unprocessableContentHandler: t,
  internalErrorHandler: d,
  afterFetch: r,
  accessDeniedHandler: c,
  onErrorBeforeErrorHandlers: _,
  onNotFound: u,
  mock: i
}) {
  const m = T(), { t: s } = Q(), [y, g] = P(0), [b, I] = P(!1);
  return D(() => I(!!y), [y]), { fetcher: U(
    async (...l) => {
      var h, w, E;
      g((e) => e + 1);
      const L = typeof process < "u" && ((h = process.env) == null ? void 0 : h.NODE_ENV) === "development" || typeof process < "u" && ((w = process.env) == null ? void 0 : w.NEXT_PUBLIC_APP_ENV) === "development" || typeof process < "u" && ((E = process.env) == null ? void 0 : E.APP_ENV) === "development";
      return (i && L ? new Promise((e, N) => {
        const B = i.delay ?? 3e3;
        setTimeout(() => {
          i.error ? N(i.error) : e(i.data);
        }, B);
      }) : A[a](
        l[0],
        l[1],
        l[2]
      ).then(async (e) => e && (r ? await r(e.data, e) : e.data))).catch(_).catch(async (e) => {
        if (typeof window < "u" && e instanceof X)
          u ? u(e) : process.env.NODE_ENV !== "development" && m.replace("/not-found");
        else if (typeof window < "u" && e instanceof F)
          c ? c(e) : m.push("/403");
        else if (typeof window < "u" && e instanceof G)
          f ? f(e) : window.location.assign(e.redirect);
        else if (e instanceof R)
          o.error(s("core.error.maintenance_error"));
        else if (typeof window < "u" && e instanceof j)
          d ? d(e) : o.error(s("core.error.internal_error_message"));
        else if (e instanceof M)
          p && e.errors && K(e.errors.fields) && o.error(s("global.errors.fields_toast_message")), n ? n(e) : e.message && o.error(
            /* @__PURE__ */ v(
              "p",
              {
                className: "primary-link-container",
                dangerouslySetInnerHTML: { __html: e.message }
              }
            )
          );
        else if (e instanceof S)
          o.error(s("core.error.conflict_error_message"));
        else if (e instanceof J)
          t ? t(e) : o.error(e.message || s("core.error.conflict_error_message"));
        else if (e instanceof q)
          o.error(e.message);
        else if (e instanceof k)
          o.error(s("core.error.payload_to_large_error_message"));
        else if (e instanceof x)
          o.error(/* @__PURE__ */ v("p", { dangerouslySetInnerHTML: { __html: e.message } }));
        else {
          if (e instanceof V)
            throw e;
          !(C(e) || e.code === "ECONNABORTED") && o.error(s("global.error"));
        }
        if (!O)
          throw e;
      }).finally(() => g((e) => e - 1));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      a,
      r,
      m,
      f,
      p,
      n,
      t,
      c,
      _
    ]
  ), isFetching: b };
};
export {
  _e as getUseBaseFetch
};
